import { render, staticRenderFns } from "./ContentSourceView.vue?vue&type=template&id=2b9affc7"
import script from "./ContentSourceView.vue?vue&type=script&lang=js"
export * from "./ContentSourceView.vue?vue&type=script&lang=js"
import style0 from "./ContentSourceView.vue?vue&type=style&index=0&id=2b9affc7&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports